import React, { useState } from "react";

const shimmerStyle: React.CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  borderRadius: "8px",
  overflow: "hidden",
  zIndex: 2,
  background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
  backgroundSize: "200% 100%",
  animation: "shimmer 2s infinite",
};

const shimmerKeyframes = `
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
`;

const SupportVideo = ({ onClose }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <div className="createbot-modal">
      <style>{shimmerKeyframes}</style>
      <div className="relative aspect-[5/2.5] w-[80%]">
        {!isLoaded && <div style={shimmerStyle} />}
        <iframe
          src="https://app.supademo.com/embed/cmd4bdibs4hczc4kjdkoxjylj?embed_v=2"
          loading="lazy"
          title="Build and train a chatbot with Chatbotbuilder.net"
          allow="clipboard-write"
          frameBorder="0"
          // webkitallowfullscreen="true"
          // mozallowfullscreen="true"
          allowFullScreen
          style={{
            width: "100%",
            height: "100%",
            visibility: isLoaded ? "visible" : "hidden",
          }}
          onLoad={() => setIsLoaded(true)}
        ></iframe>
        <div className="close flex-cnt" onClick={onClose}>
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="#6D6D6D"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 1.00714L8.99286 0L5 3.99286L1.00714 0L0 1.00714L3.99286 5L0 8.99286L1.00714 10L5 6.00714L8.99286 10L10 8.99286L6.00714 5L10 1.00714Z"
              fill="#6D6D6D"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default SupportVideo;
